export default __webpack_public_path__ + "static/media/lose.e06b87f8.png";